import isContractReview from "utils/is_contract_review";

export default function(text) {
  document.title = `${
    isContractReview() ? "Contract-Review.com" : "Lexical Labs"
  }${text ? ` - ${text}` : ""}`;
}
